<script lang="ts">
	import type { Media } from "@core/schema/Media.js";
	import { getUploadedFilePath } from "@core/utils/getUploadedFilePath.js";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";
	import MediaComponent from "./common/Media.svelte";
	import type { MediaSrc } from "./common/MediaSrc.js";

	const componentId = $props.id();
	const {
		mediaSrc,
		secondary,
		alt,
		class: mediaClass,
	}:
		| { mediaSrc: MediaSrc; secondary?: false; alt: string; class?: string }
		| { mediaSrc: Media; secondary: true; alt: string; class?: string } = $props();
	const { FILE_BUCKET_URL_MAP } = getGlobalSettings();
</script>

<svelte:head>
	{#if secondary}
		<link rel="preload" as="image" href={getUploadedFilePath(mediaSrc, FILE_BUCKET_URL_MAP)} fetchpriority="low" />
	{/if}
</svelte:head>

<MediaComponent
	{alt}
	width={328}
	height={328}
	source={mediaSrc}
	sourcesets={{
		">sm": [400, 400],
		"<sm": [400, 400],
		">md": [500, 500],
	}}
	lightbox={"youtube" in mediaSrc && componentId}
	wrapperClass={[
		"absolute inset-0 size-full bg-inherit",
		secondary &&
			"z-10 pointer-events-none opacity-0 [a:hover>&]:opacity-100 group-hover/product-card:opacity-100 transition-opacity duration-500",
	]}
	lightboxClass="!absolute inset-0 size-full"
	class={["size-full object-cover", mediaClass]}
/>
